import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/privacy-policy-content/privacy-policy-content.tsx");
